export const reel2 = {
    id: 'reel-2',
    schemaVersion: 2,
    covers: "A numbered rundown: a hook, four numbered items, then a call to action. Suits 'four things about X' — a list with equal-weight points.",
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 840,
    },
    root: {
        kind: 'leaf',
        id: 'main',
        spine: [
            {
                kind: 'media-track',
                id: 'broll',
                duration: {
                    kind: 'fill',
                },
                clips: {
                    source: 'query',
                    query: {
                        kind: 'asset-clips',
                        tag: 'procedure',
                        count: [1, 15],
                    },
                    required: true,
                },
                fit: 'contain-blur',
                kenBurnsOnImages: true,
                cuts: {
                    mode: 'at',
                    at: [
                        {
                            atSec: 0.867,
                            transition: 'cut',
                        },
                        {
                            atSec: 2.2,
                            transition: 'cut',
                        },
                        {
                            atSec: 3.133,
                            transition: 'fade',
                        },
                        {
                            atSec: 3.433,
                            transition: 'fade',
                        },
                        {
                            atSec: 5.033,
                            transition: 'cut',
                        },
                        {
                            atSec: 5.9,
                            transition: {
                                mask: 'wedge-up-right',
                            },
                        },
                        {
                            atSec: 10.8,
                            transition: 'fade',
                        },
                        {
                            atSec: 11.067,
                            transition: 'fade',
                        },
                        {
                            atSec: 16.067,
                            transition: 'fade',
                        },
                        {
                            atSec: 16.333,
                            transition: 'fade',
                        },
                        {
                            atSec: 17.867,
                            transition: 'fade',
                        },
                        {
                            atSec: 19.567,
                            transition: {
                                mask: 'split-bars',
                            },
                        },
                        {
                            atSec: 20.267,
                            transition: 'cut',
                        },
                        {
                            atSec: 21.9,
                            transition: 'fade',
                        },
                        {
                            atSec: 22.4,
                            transition: 'fade',
                        },
                    ],
                },
            },
        ],
        overlays: [
            {
                kind: 'group',
                id: 'open-fade',
                start: {
                    at: 'frame',
                    value: 0,
                },
                duration: {
                    kind: 'fixed',
                    frames: 11,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: '#000000',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                anchor: {
                                    at: 'start',
                                    frame: 1,
                                },
                                duration: 10,
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'scene-0',
                start: {
                    at: 'frame',
                    value: 8,
                },
                duration: {
                    kind: 'fixed',
                    frames: 112,
                },
                placement: {
                    anchor: 'center',
                    x: 0.499,
                    y: 0.413,
                    width: 0.64,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'hook',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 70,
                                fontWeight: 500,
                                lineHeight: 1.14,
                            },
                            align: 'center',
                            motion: {
                                token: 'letter-fade-scattered',
                                durationFrames: 60,
                            },
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'scene-1',
                start: {
                    at: 'frame',
                    value: 147,
                },
                duration: {
                    kind: 'fixed',
                    frames: 89,
                },
                placement: {
                    anchor: 'center',
                    x: 0.501,
                    y: 0.507,
                    width: 0.695,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 34,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'literal',
                                text: '1',
                            },
                            style: 'caption',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                fontSize: 42,
                                fontWeight: 500,
                                letterSpacing: 0,
                            },
                            align: 'center',
                            container: {
                                borderColor: 'rgba(255,255,255,0.62)',
                                borderWidth: 3,
                                radius: 999,
                                width: 133,
                                height: 133,
                                center: true,
                            },
                            entrance: 'spring-in',
                            entranceDurationFrames: 12,
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'item1',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 56,
                                fontWeight: 500,
                                lineHeight: 1.13,
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 6,
                            align: 'center',
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'scene-2',
                start: {
                    at: 'frame',
                    value: 260,
                },
                duration: {
                    kind: 'fixed',
                    frames: 88,
                },
                placement: {
                    anchor: 'center',
                    x: 0.498,
                    y: 0.491,
                    width: 0.665,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 34,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'literal',
                                text: '2',
                            },
                            style: 'caption',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                fontSize: 42,
                                fontWeight: 500,
                                letterSpacing: 0,
                            },
                            align: 'center',
                            container: {
                                borderColor: 'rgba(255,255,255,0.62)',
                                borderWidth: 3,
                                radius: 999,
                                width: 133,
                                height: 133,
                                center: true,
                            },
                            entrance: 'spring-in',
                            entranceDurationFrames: 12,
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'item2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 56,
                                fontWeight: 500,
                                lineHeight: 1.13,
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 6,
                            align: 'center',
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'scene-3',
                start: {
                    at: 'frame',
                    value: 374,
                },
                duration: {
                    kind: 'fixed',
                    frames: 89,
                },
                placement: {
                    anchor: 'center',
                    x: 0.506,
                    y: 0.508,
                    width: 0.62,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 34,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'literal',
                                text: '3',
                            },
                            style: 'caption',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                fontSize: 42,
                                fontWeight: 500,
                                letterSpacing: 0,
                            },
                            align: 'center',
                            container: {
                                borderColor: 'rgba(255,255,255,0.62)',
                                borderWidth: 3,
                                radius: 999,
                                width: 133,
                                height: 133,
                                center: true,
                            },
                            entrance: 'spring-in',
                            entranceDurationFrames: 12,
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'item3',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 56,
                                fontWeight: 500,
                                lineHeight: 1.13,
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 6,
                            align: 'center',
                        },
                    ],
                },
                ridesWith: {
                    track: 'broll',
                },
            },
            {
                kind: 'group',
                id: 'scene-4',
                start: {
                    at: 'frame',
                    value: 488,
                },
                duration: {
                    kind: 'fixed',
                    frames: 87,
                },
                placement: {
                    anchor: 'center',
                    x: 0.499,
                    y: 0.523,
                    width: 0.645,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 34,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'literal',
                                text: '4',
                            },
                            style: 'caption',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                fontSize: 42,
                                fontWeight: 500,
                                letterSpacing: 0,
                            },
                            align: 'center',
                            container: {
                                borderColor: 'rgba(255,255,255,0.62)',
                                borderWidth: 3,
                                radius: 999,
                                width: 133,
                                height: 133,
                                center: true,
                            },
                            entrance: 'spring-in',
                            entranceDurationFrames: 12,
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'item4',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 56,
                                fontWeight: 500,
                                lineHeight: 1.13,
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 6,
                            align: 'center',
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'scene-5',
                start: {
                    at: 'frame',
                    value: 609,
                },
                duration: {
                    kind: 'fixed',
                    frames: 87,
                },
                placement: {
                    anchor: 'center',
                    x: 0.499,
                    y: 0.818,
                    width: 0.71,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 14,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'ctaLead',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 65,
                                fontWeight: 500,
                                lineHeight: 1.14,
                                fontStyle: 'italic',
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 8,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'ctaBody',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 56,
                                fontWeight: 500,
                                lineHeight: 1.13,
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 8,
                            align: 'center',
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'card-0',
                start: {
                    at: 'frame',
                    value: 672,
                },
                duration: {
                    kind: 'fixed',
                    frames: 168,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: '#120D07',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                        adoptLogoScrim: true,
                    },
                },
            },
            {
                kind: 'group',
                id: 'brand-card-0',
                start: {
                    at: 'frame',
                    value: 683,
                },
                duration: {
                    kind: 'fixed',
                    frames: 157,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5079,
                    y: 0.3692,
                    width: 0.62,
                },
                root: {
                    kind: 'logo',
                    url: {
                        source: 'query',
                        query: {
                            kind: 'brand',
                            field: 'logoUrl',
                        },
                        required: false,
                    },
                    width: 1,
                    entrance: 'fade-in',
                    entranceDurationFrames: 20,
                },
            },
            {
                kind: 'rect',
                id: 'bar-offer',
                start: {
                    at: 'frame',
                    value: 682,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.5007,
                    y: 0.5805,
                    width: 0.7986,
                    height: 0.0625,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-offer',
                start: {
                    at: 'frame',
                    value: 682,
                },
                duration: {
                    kind: 'fixed',
                    frames: 158,
                },
                placement: {
                    anchor: 'center',
                    x: 0.498,
                    y: 0.5761,
                    width: 0.78,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'offer1',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 51.3,
                                fontWeight: 300,
                                fontStyle: 'italic',
                                lineHeight: 1.05,
                                whiteSpace: 'nowrap',
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'offer2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 51.3,
                                fontWeight: 300,
                                fontStyle: 'italic',
                                lineHeight: 1.05,
                                whiteSpace: 'nowrap',
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'rect',
                id: 'bar-cta',
                start: {
                    at: 'frame',
                    value: 690,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.4993,
                    y: 0.6375,
                    width: 0.7986,
                    height: 0.0234,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-cta',
                start: {
                    at: 'frame',
                    value: 690,
                },
                duration: {
                    kind: 'fixed',
                    frames: 150,
                },
                placement: {
                    anchor: 'center',
                    x: 0.4986,
                    y: 0.6374,
                    width: 0.9,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'cta',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 34.4,
                                fontWeight: 100,
                                lineHeight: 1.1,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.11,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'rect',
                id: 'bar-tagline',
                start: {
                    at: 'frame',
                    value: 695,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.7656,
                    width: 0.9138,
                    height: 0.0516,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-tagline',
                start: {
                    at: 'frame',
                    value: 695,
                },
                duration: {
                    kind: 'fixed',
                    frames: 145,
                },
                placement: {
                    anchor: 'center',
                    x: 0.4996,
                    y: 0.7652,
                    width: 0.86,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'tagline1',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 44.1,
                                fontWeight: 100,
                                lineHeight: 1.06,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.048,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'tagline2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 44.1,
                                fontWeight: 100,
                                lineHeight: 1.06,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.048,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
    content: {
        hook: {
            type: 'text',
            maxChars: 70,
            description: 'The opening line, one sentence that WRAPS over about three lines — not one field per line. Use *italic* around a phrase for emphasis and **bold** for weight; the markers never render.',
        },
        item1: {
            type: 'text',
            maxChars: 78,
            description: 'Numbered item 1, one sentence that wraps. Use *italic* around a phrase for emphasis and **bold** for weight; the markers never render.',
        },
        item2: {
            type: 'text',
            maxChars: 78,
            description: 'Numbered item 2, one sentence that wraps. Use *italic* around a phrase for emphasis and **bold** for weight; the markers never render.',
        },
        item3: {
            type: 'text',
            maxChars: 78,
            description: 'Numbered item 3, one sentence that wraps. Use *italic* around a phrase for emphasis and **bold** for weight; the markers never render.',
        },
        item4: {
            type: 'text',
            maxChars: 78,
            description: 'Numbered item 4, one sentence that wraps. Use *italic* around a phrase for emphasis and **bold** for weight; the markers never render.',
        },
        ctaLead: {
            type: 'text',
            maxChars: 40,
            description: 'The closing question, one line, set a size up. Use *italic* around a phrase for emphasis and **bold** for weight; the markers never render.',
        },
        ctaBody: {
            type: 'text',
            maxChars: 60,
            description: 'The closing answer, one sentence that wraps over two lines. Use *italic* around a phrase for emphasis and **bold** for weight; the markers never render.',
        },
        offer1: {
            type: 'text',
            maxChars: 34,
            description: "The first of two lines naming something CONCRETE the viewer can take up — a consultation, a patch test, a named treatment, a specific package. Name the thing itself; 'our range of services' is not an offer. Set in italic sans, apart from the rest of the card.",
        },
        offer2: {
            type: 'text',
            maxChars: 34,
            description: 'The second offer line, completing the first rather than starting a new one — the condition, the timing, or what is included. The two lines are read together as one offer.',
        },
        cta: {
            type: 'text',
            maxChars: 46,
            description: "The end-card call to action: the single action to take, as a verb phrase — 'Book a consultation', 'Message us to check your suitability'. An instruction, not a slogan. May carry **bold** runs on the words that matter.",
        },
        tagline1: {
            type: 'text',
            maxChars: 30,
            description: "The first of two closing tagline lines — the clinic's standing promise, not anything specific to this treatment. May carry *italic* runs.",
        },
        tagline2: {
            type: 'text',
            maxChars: 30,
            description: 'The second tagline line, completing the first. The two are read as one phrase, so it must not restate line one.',
        },
    },
    structure: 'A diagnosis. `hook` states a problem the viewer already has and promises the reasons for it; `item1`-`item4` are those REASONS, each a complete sentence, all four answering the same question the hook asked; `ctaLead` asks what to do instead and `ctaBody` answers with the service. An item that is a benefit, a tip, or a fact rather than a reason breaks the format. The source is: "This is why your skincare routine isn\'t delivering results." followed by four causes, then "The secret to real results? A bespoke consultation with our Skin Experts."',
};
//# sourceMappingURL=reel-2.js.map